const headerData = [
  {
    id: 1,
    name: "S.No",
    width: "5%",
    paddingRight: "3.8%",
    paddingLeft: "1.5%",
  },
  {
    id: 2,
    name: "Quiz Name",
    width: "11%",
    paddingRight: "3.3%",
  },
  {
    id: 3,
    name: "Created on",
    width: "11.1%",
    paddingRight: "3.3%",
  },
  {
    id: 4,
    name: "Impression",
    width: "10%",
    paddingRight: "4.4%",
  },
  {
    id: 5,
    name: "",
    width: "10%",
    paddingRight: "4.8%",
  },
  {
    id: 6,
    name: "",
  },
];

export { headerData };
